import React from 'react';
import { GraduationCapIcon, AwardIcon, UsersIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { boardService, civicLeadership, education } from '../data/profile';
export function BoardEducation() {
  return <PageShell path="/board-education" data-id="element-151" data-mp="2009jkgu5g5e6">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="board-service-heading" data-id="element-152" data-mp="1zz7z5lr8u6js">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-153" data-mp="1v1oiygazjjp7">
          <div id="board-service-heading" data-id="element-154" data-mp="1q08xin4wbb6a">
            <SectionHeading eyebrow="Board & Committee Service" title="Governance forums founded, chaired and served" data-id="element-155" data-mp="1q3dbgc85xla5" />
          </div>

          <ul className="mt-12 border-t border-platinum-200" data-id="element-156" data-mp="1h26oplex7e8g">
            {boardService.map(service => <li key={service.body} className="grid grid-cols-1 gap-6 border-b border-platinum-200 py-8 lg:grid-cols-12 lg:gap-12" data-id="element-157" data-mp="3fffec8aaydnb">
                <div className="lg:col-span-4" data-id="element-158" data-mp="1s12r0comrzec">
                  <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-159" data-mp="1x0xhwg8eooze">
                    {service.period}
                  </p>
                  <h3 className="mt-3 font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-160" data-mp="1j2z4bd1wswky">
                    {service.body}
                  </h3>
                </div>
                <div className="lg:col-span-8" data-id="element-161" data-mp="2asvig2o1xcjy">
                  <p className="font-display text-base font-semibold text-navy-900" data-id="element-162" data-mp="2fr5eefhloh6m">{service.role}</p>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-charcoal-600 lg:text-base" data-id="element-163" data-mp="220a55236vy2i">
                    {service.detail}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="education-heading" data-id="element-164" data-mp="2tpwmnl9s78mu">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-165" data-mp="2yj7of7zqkz7w">
          <div className="lg:col-span-5" data-id="element-166" data-mp="38bkd1o6kv9e5">
            <div id="education-heading" data-id="element-167" data-mp="34c1rqraugwas">
              <SectionHeading eyebrow="Education & Certification" title="Formal qualifications" data-id="element-168" data-mp="34a74v7g0iu42" />
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-169" data-mp="2uedv1vtohepz">
            <div className="flex items-start gap-5 border-b border-platinum-300 pb-8" data-id="element-170" data-mp="2udc8au3av3sf">
              <GraduationCapIcon className="mt-1 h-6 w-6 shrink-0 text-gold-600" aria-hidden="true" data-id="element-171" data-mp="2pg2k1hrncy66" />
              <div data-id="element-172" data-mp="2kn9e4qkfzjsi">
                <p className="font-display text-xl font-bold tracking-tight text-navy-900" data-id="element-173" data-mp="2kn13l5bskqkh">
                  {education.degree}
                </p>
                <p className="mt-2 font-sans text-sm text-charcoal-600" data-id="element-174" data-mp="2bo5xdt8qzgh6">{education.degreeDetail}</p>
              </div>
            </div>

            <div className="flex items-start gap-5 pt-8" data-id="element-175" data-mp="26n87euhhxi54">
              <AwardIcon className="mt-1 h-6 w-6 shrink-0 text-gold-600" aria-hidden="true" data-id="element-176" data-mp="21pq1ze2otl1v" />
              <div className="w-full" data-id="element-177" data-mp="1rlrugfp5a8mc">
                <p className="font-display text-base font-bold tracking-tight text-navy-900" data-id="element-178" data-mp="1rkq8vhai63qd">
                  Advanced certifications
                </p>
                <ul className="mt-4 divide-y divide-platinum-300 border-y border-platinum-300" data-id="element-179" data-mp="21jyxdumlmq5c">
                  {education.certifications.map(certification => <li key={certification.name} className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 py-3.5" data-id="element-180" data-mp="26gpp5f7rna6l">
                      <span className="font-sans text-base font-medium text-navy-900" data-id="element-181" data-mp="1duegridx44z8">
                        {certification.name}
                      </span>
                      <span className="font-sans text-xs uppercase tracking-[0.14em] text-charcoal-600" data-id="element-182" data-mp="1nkzllnk6q5ql">
                        {certification.detail}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy-900 py-20 lg:py-24" aria-labelledby="civic-heading" data-id="element-183" data-mp="2wtc8fpoqgeir">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-184" data-mp="2rv0yzg2co612">
          <div id="civic-heading" data-id="element-185" data-mp="36j48v0jik1v5">
            <SectionHeading eyebrow="Civic Leadership" title="Contribution beyond the organisation" tone="dark" data-id="element-186" data-mp="36jdwwikzzyy7" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px bg-white/10 lg:grid-cols-3" data-id="element-187" data-mp="3fi97e6v2rv7b">
            {civicLeadership.map(item => <li key={item.title} className="flex flex-col bg-navy-900 p-8" data-id="element-188" data-mp="3bhfjveljoiey">
                <UsersIcon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-189" data-mp="3pg5hqwg6um4d" />
                <h3 className="mt-5 font-display text-base font-bold leading-snug text-white" data-id="element-190" data-mp="3kjf044oqjigu">
                  {item.title}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-191" data-mp="1v5jpeq08xzu3">
                  {item.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}